export const fetchNotificationApi = (setGetNotification, BeURL, showAlert, perPage = 1, currentPage = 1, setTotalPages, setTotalCount) => {

    fetch(`${BeURL}/fetch-notification`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({ perPage, currentPage })
    })
    .then(res => res.json())
    .then(data => {
        if (data.success === true) {
            setGetNotification(data?.notifications)
            setTotalPages(data?.totalPage || 1)
            setTotalCount(data?.totalCount || 0)
        }
        else {
            showAlert(data.message)
            setGetNotification([])
        }
    })
    .catch(err => {
        console.log("Error while get notification:", err);
        alert("Unable to get notifiation. Please try again later.");
    })

}

export const notificationReadActionApi = (id, BeURL) => {
    if (!id || !BeURL) {
        return;
    }

    fetch(`${BeURL}/ticket-read-status`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ id })
    })
    .then(res => res.json())
    .then(data => {
        if (data?.success === true) {
            alert(data.message)
            window.location.reload()
        }
        else {
            alert(data.message)
        }
    })
    .catch(err => {
        console.log("Error while raising ticket:", err);
        alert("Unable to raise ticket. Please try again later.");
    })
}

export const notificationReadActionApiAll = (id, BeURL) => {
    fetch(`${BeURL}/ticket-read-status-all`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ id })
    })
    .then(res => res.json())
    .then(data => {
        if (data?.success === true) {
            alert(data.message)
            window.location.reload()
        }
        else {
            alert(data.message)
        }
    })
    .catch(err => {
        console.log("Error while raising ticket:", err);
        alert("Unable to raise ticket. Please try again later.");
    })
}